import React from 'react';

import { Grid, Link, Typography } from '@hbf/dsl';

interface Props {
  text: React.ReactNode;
  url?: string;
  renderAsLink: boolean;
}

const BreadcrumbItem: React.FC<Props> = ({ text, url, renderAsLink }) => {
  const isLink = renderAsLink && url;

  const textElement = (
    <Typography.Caption
      color={isLink ? 'default' : 'muted'}
      fontWeight={isLink ? 'bold' : 'normal'}
    >
      <Grid container>{text}</Grid>
    </Typography.Caption>
  );

  return isLink ? <Link to={url!}>{textElement}</Link> : textElement;
};

export { BreadcrumbItem };
